import { useMutation, useLazyQuery } from '@apollo/client'
import {
  CREATE_NORMAL_CAMPAIGN,
  GET_CAMPAIGN_DETAIL,
  REQUEST_APPROVE_CAMPAIGN,
  UPDATE_NORMAL_CAMPAIGN,
} from 'queries/campaignNormal.queries'
import { useHandleResponseAPI } from 'hooks'

function useCampaignNormal() {
  const [getCampaign, { data, loading, error, refetch }] = useLazyQuery(GET_CAMPAIGN_DETAIL, {
    fetchPolicy: 'no-cache',
  })

  const [createNormalCampaign, optionCreate] = useMutation(CREATE_NORMAL_CAMPAIGN)
  const [updateNormalCampaign, optionUpdate] = useMutation(UPDATE_NORMAL_CAMPAIGN)
  const [requestApproveCampaign, optionRequestApprove] = useMutation(REQUEST_APPROVE_CAMPAIGN)

  const isLoading: boolean = loading || optionCreate.loading || optionUpdate.loading || optionRequestApprove.loading

  const errMsg = (): string => {
    // Query
    if (error || data?.campaignDetail?.res_code === '99') return JSON.stringify(error || data?.campaignDetail?.res_desc)

    // optionUpdate
    if (optionUpdate.error || optionUpdate.data?.updateNormalCampaign?.res_code === '99')
      return JSON.stringify(optionUpdate.error || optionUpdate.data?.updateNormalCampaign?.res_desc)

    // optionCreate
    if (optionCreate.error || optionCreate.data?.createNormalCampaign?.res_code === '99')
      return JSON.stringify(optionCreate.error || optionCreate.data?.createNormalCampaign?.res_desc)

    // optionRequestApprove
    if (optionRequestApprove.error || optionRequestApprove.data?.requestApproveCampaign?.res_code === '99')
      return JSON.stringify(optionRequestApprove.error || optionRequestApprove.data?.requestApproveCampaign?.res_desc)

    return ''
  }

  useHandleResponseAPI({
    isLoading: isLoading,
    errMsg: errMsg(),
  })

  return {
    getCampaign,
    createNormalCampaign,
    updateNormalCampaign,
    requestApproveCampaign,
    refetch,
  }
}

export default useCampaignNormal
